import React, { useState, useEffect, Fragment } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Table } from "react-bootstrap";
import Edit from "./Edit";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";
import HandleHttpErrors from "../../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API;

const Listdelete = ({ increment, counter, setCounter }) => {
  const [hakalaReasons, setHakalaReasons] = useState(null);
  const [hakalaId, setHakalaId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");

  //const handleShowModal = () => setShow(true);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get("/jobs/hakalareason/", {
          signal: controller.signal,
        });

        isMounted && setHakalaReasons(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [counter]);
  const handleEditClick = (event, hakala) => {
    event.preventDefault();
    setHakalaId(hakala.id);
  };
  const handleCancelClick = () => {
    setHakalaId(null);
  };

  if (!hakalaReasons) return null;
  return (
    <>
      <div className="mx-auto">
        <Row>
          <Col sm="10" md={{ size: 3, offset: 1 }}>
            <form onSubmit={increment}>
              <Table hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>סיבה</th>
                    <th>פעולות</th>
                  </tr>
                </thead>
                <tbody>
                  {hakalaReasons?.map((hakala) => (
                    <Fragment key={hakala.id}>
                      {hakalaId === hakala.id ? (
                        <Edit
                          hakala={hakala}
                          handleCancelClick={handleCancelClick}
                          increment={increment}
                          counter={counter}
                          setHakalaId={setHakalaId}
                        />
                      ) : (
                        <ReadOnlyRows
                          hakala={hakala}
                          handleEditClick={handleEditClick}
                          increment={increment}
                          setHakalaId={setHakalaId}
                          setShowError={setShowError}
                          setErrorMessage={setErrorMessage}
                          setErrorHeader={setErrorHeader}
                        />
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </Table>
            </form>
          </Col>
        </Row>
      </div>

      <ErrorModal
        showError={showError}
        setShowError={setShowError}
        errorMessage={errorMessage}
        errorHeader={errorHeader}
      />
    </>
  );
};
export default Listdelete;

const ReadOnlyRows = ({
  hakala,
  handleEditClick,
  setHakalaId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);

  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת מחלקת "${hakala.title}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const delData = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "jobs/hakalareason/" + hakala.id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    delData();
    setHakalaId(null);
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={hakala.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>{hakala.id}</td>
        <td>{hakala.title}</td>
        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, hakala)}
          >
            <FiEdit2 />
          </button>
          <span> </span>
          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) =>
              showDeleteModal("hakalareason", hakala.id, event)
            }
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
    </>
  );
};
